import "./MiddleBox.scss";
import cupcakes from "../../assets/images/cupcakes.jpg";

const MiddleBox = () => {
  return (
    <div className="middle-box">
      <img src={cupcakes} alt="home" className="middle-box__img" />
      <div className="middle-box__container">
        <h1 className="middle-box__title">What?</h1>
        <p className="middle-box__text">
          My knowledge base started to grow, and I started to bake and more
          often for practice and fun. Though I didn't tell many people outside
          the few that I was baking for.
        </p>
      </div>
    </div>
  );
};

export default MiddleBox;
